import ApplicationController from './application_controller';
// A bid's currency, out of the row's way: the select sits collapsed under the MRC field, and the toggle
// shows the currency it holds, so a bid in dollars reads as dollars at a glance (SPI-23 kept the currency
// explicit; the collapse keeps it visible without crowding the row). The select's change and Bootstrap's
// collapse events keep the label and chevron in step.
class default_1 extends ApplicationController {
    connect() {
        super.connect();
        this.sync();
        if (this.hasCollapseTarget) {
            this.addEventListener(this.collapseTarget, 'shown.bs.collapse', () => this.setExpanded(true));
            this.addEventListener(this.collapseTarget, 'hidden.bs.collapse', () => this.setExpanded(false));
        }
    }
    // The select changed: the toggle shows the new currency.
    sync() {
        if (this.hasSelectTarget && this.hasLabelTarget) {
            this.labelTarget.textContent = this.selectTarget.value;
        }
    }
    setExpanded(expanded) {
        if (this.hasIconTarget) {
            this.iconTarget.classList.toggle('fa-chevron-up', expanded);
            this.iconTarget.classList.toggle('fa-chevron-down', !expanded);
        }
    }
}
default_1.targets = ['label', 'select', 'icon', 'collapse'];
export default default_1;
